<template>
  <b-row>
    <b-col md="12">
      <h2 class="text-center mt-2 mb-5">
        ¿Quiénes Somos?
      </h2>
      <b-row
        class="mx-md-3 mx-lg-3"
        align-v="center"
      >
        <b-col md="6">
          <b-img
            :src="`${delivery}publico/paginas/nosotros/indetec_nosotros.jpg`"
            fluid-grow
            alt="Nosotros Indetec Campus virtual"
          />
        </b-col>
        <b-col md="6">
          <p class="mx-1 my-2 text-justify">
            El Instituto para el Desarrollo Técnico de las Haciendas Públicas (INDETEC) es un Organismo Público del Sistema Nacional de Coordinación Fiscal con personalidad jurídica y patrimonio propio, creado por disposición de la Ley de Coordinación Fiscal (LCF) conforme a la fracción III del artículo 16 y 22 primer párrafo.
          </p>
          <p class="m-1 text-justify">
            De acuerdo a la fracción VII, artículo 22 de la LCF, INDETEC tiene como una de sus funciones la de capacitar técnicos y funcionarios fiscales, lo cual debe realizar con la más alta exigencia a partir de un manejo riguroso y metodológico de la materia tributaria, fiscal y en general hacendaria; de modo que el funcionariado pueda llevar a cabo en forma activa, analítica, creativa y crítica las funciones encomendadas.
          </p>
        </b-col>
      </b-row>
      <b-row
        class="mx-md-2 mx-lg-3"
        align-v="center"
      >
        <b-col md="12">
          <p class="mx-1 my-2 text-justify">
            Asimismo, conforme a los artículos 17, primer párrafo y 19 fracción III de la LCF, la Reunión Nacional de Funcionarios Fiscales, integrada por el Secretario de Hacienda y Crédito Público y por el titular del órgano hacendario de cada entidad, funge como Asamblea General de INDETEC, y mediante el acuerdo 48/7 tomado en la XLVIII Reunión Nacional de Funcionarios Fiscales del 27 de noviembre de 2019, aprobó agregar dentro de las funciones de INDETEC “la de realizar planes de estudio de educación superior, entre ellos Maestrías y Especialidades; así como programas de certificación de competencias, con el objetivo de profesionalizar a los funcionarios de las haciendas públicas del país, y con ello coadyuvar al desarrollo técnico institucional de los órganos hacendarios”.
          </p>
        </b-col>
      </b-row>

      <b-row class="mx-md-3 mx-lg-3">
        <b-col
          lg="12"
          class="m-3"
        >
          <hr>
          <h2 class="text-center m-5">
            Nuestro Enfoque
          </h2>
          <b-tabs
            pills
            vertical
          >
            <b-tab
              title="Histórico"
              active
            >
              <blockquote class="border-left-secondary border-left-3">
                <p class="mx-3 text-justify">
                  Desde hace cinco décadas INDETEC ha coadyuvado a la formación profesional de funcionarios hacendarios, al impartir cursos de capacitación en temas de la Hacienda Pública, así como varias ediciones de dos programas de Especialización:
                  el Programa de Especialización en Fiscalización de Impuestos Federales Coordinados
                  y el Programa de Especialización en Administración Hacendaria Municipal.
                </p>
                <p class="mx-3 text-justify">
                  Cada programa de Especialización se impartía de manera presencial, y durante un mes servidoras y servidores públicos de todo el país se dedicaban de tiempo completo al programa. Estos programas se impartieron con el propósito de proporcionar a los funcionarios hacendarios las competencias básicas relacionadas con la fiscalización de impuestos federales coordinados, o bien, la administración hacendaria municipal. Si bien estos programas no contaron con Reconocimiento de Validez Oficial de Estudios (RVOE), sus egresados se destacaron por aplicar en sus labores los conocimientos adquiridos, con un impacto favorable para la Hacienda Pública del ente público.
                </p>
                <p class="mx-3 text-justify">
                  Por otra parte, en los últimos 15 años, los temas de la Hacienda Pública se han ampliado, de manera que la contabilidad gubernamental, la gestión para resultados, la disciplina financiera, la transparencia y la rendición de cuentas se han sumado a los avances de las tecnologías de la información y la comunicación, lo que ha traído consigo nuevas responsabilidades para los funcionarios hacendarios, así como nuevas oportunidades para continuar los estudios superiores en modalidad a distancia.
                </p>
                <p class="mx-3 text-justify">
                  Así es como el
                  <b>5 de febrero de 2020, con RVOE CIE14201902</b>
                  INDETEC obtuvo el reconocimiento para impartir la Especialidad en Fiscalización de Impuestos en México, lo que ha implicado avanzar hacia una nueva etapa en la profesionalización de los funcionarios hacendarios, en particular los estudios de posgrado en modalidad a distancia, y a partir del 30 de agosto de 2021, inicia la primera generación de esta Especialidad. El Instituto está preparando otros programas de posgrado.
                </p>
              </blockquote>
            </b-tab>
            <b-tab title="Dirección y Rumbo">
              <blockquote class="border-left-secondary border-left-3">
                <p class="mx-3 text-justify">
                  Posgrados INDETEC está orientado a resolver las necesidades de educación superior de los funcionarios hacendarios, y lo hace bajo la modalidad a distancia para permitirles compaginar el desempeño de las responsabilidades laborales con el estudio de un posgrado en alguno de los temas de la Hacienda Pública, con reconocimiento de validez oficial y un compromiso por la calidad educativa.
                </p>
              </blockquote>
            </b-tab>
            <b-tab title="Recurso humano">
              <blockquote class="border-left-secondary border-left-3">
                <p class="mx-3 text-justify">
                  Para tales efectos, el INDETEC se ha integrado de manera interdisciplinaria con profesionales especialistas en las áreas de: Derecho, Contaduría, Economía, Administración Pública e Informática, así como todas, de alguna manera, coadyuvan la labor de análisis e interpretación de los fenómenos relacionados con la materia fiscal y hacendaria.
                </p>
              </blockquote>
            </b-tab>
          </b-tabs>
          <hr>
        </b-col>
      </b-row>

      <b-container class="mb-3">
        <b-row
          class="mx-md-3 mx-lg-3"
          align-v="center"
        >
          <b-col md="6">
            <hr>
            <h2 class="text-center mx-5">
              Misión
            </h2>
            <p class="mx-5 text-justify">
              Ser un área de INDETEC que apoye al Instituto en la formulación, diseño instruccional e impartición de programas de Posgrado en temas de la Hacienda Pública, en modalidad a distancia, para satisfacer las necesidades de profesionalización del funcionariado hacendario, y así contribuir al fortalecimiento técnico de las Haciendas Públicas en beneficio del desarrollo del país y el bienestar de su población.
            </p>
            <hr>
          </b-col>

          <b-col md="6">
            <b-img
              :src="`${delivery}publico/paginas/nosotros/mision_indetec.jpg`"
              fluid-grow
              alt="Mision indetec campus virtual"
            />
          </b-col>
        </b-row>
      </b-container>
      <b-container class="mb-3">
        <b-row
          class="mx-md-3 mx-lg-3"
          align-v="center"
        >
          <b-col md="6">
            <b-img
              :src="`${delivery}publico/paginas/nosotros/vision_indetec.jpg`"
              fluid-grow
              alt="Vision indetec campus virtual"
            />
          </b-col>
          <b-col md="6">
            <hr>
            <h2 class="text-center m-5">
              Visión
            </h2>
            <p class="m-5 text-justify">
              Posgrados INDETEC será el principal formador de funcionarios de carrera hacendaria de alto nivel a través de Diplomados, Especialidades, Maestrías y Doctorados en temas de la Hacienda Pública, en modalidad a distancia y con reconocimiento de validez oficial de estudios.
            </p>
            <hr>
          </b-col>
        </b-row>
      </b-container>
      <b-row
        align-v="center"
        class="mx-md-3 mx-lg-3"
      >
        <b-col md="12">
          <h2 class="text-center">
            Valores
          </h2>
          <p class="text-center m-3">
            Los valores que identifican la actuación del grupo y que son base del quehacer fundamental del INDETEC son:
          </p>
        </b-col>
      </b-row>
      <b-container class="mb-3">
        <b-row
          align-v="center"
          class="mx-md-3 mx-lg-3"
        >
          <b-col md="6">
            <b-list-group
              flush
              class="text-center"
            >
              <b-list-group-item>Honestidad</b-list-group-item>
              <b-list-group-item>Lealtad</b-list-group-item>
              <b-list-group-item>Respeto</b-list-group-item>
              <b-list-group-item>Tolerancia</b-list-group-item>
              <b-list-group-item>Responsabilidad</b-list-group-item>
              <b-list-group-item>Dignidad</b-list-group-item>
              <b-list-group-item>Compromiso</b-list-group-item>
              <b-list-group-item>Justicia</b-list-group-item>
            </b-list-group>

          </b-col>
          <b-col md="6">
            <b-img
              :src="`${delivery}publico/paginas/nosotros/valores_indetec.jpg`"
              fluid-grow
              alt="Valores indetec campus virtual"
            />
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BImg, BListGroup, BListGroupItem, BTabs, BTab, BContainer,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BListGroup,
    BListGroupItem,
    BTabs,
    BTab,
    BContainer,
  },
  setup() {
    const delivery = process.env.VUE_APP_DELIVERY_DOWNLOAD
    return {
      delivery,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
.list-group .list-group-item:hover {
    background-color: #aa9d6b;
    color:#fff;

}
.list-group .list-group-item {
    background-color: #f8f8f8;
}
h2{
color:#aa9d6b;
}
.card{
  background-color:#f8f8f8;
}
</style>
